import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Tag, Zap } from 'lucide-react';
export function PricingSection() {
  return <Section background="sage" className="text-center py-20" id="pricing" data-id="element-86">
      <div className="bg-white p-5 md:p-12 rounded-3xl shadow-xl max-w-2xl mx-auto border border-[#E8E2DA] relative overflow-hidden" data-id="element-87">
        {/* Discount ribbon */}
        <div className="absolute top-0 right-0 bg-[#D4836B] text-white px-6 py-2 text-sm font-bold rounded-bl-2xl flex items-center gap-1.5" data-id="element-88">
          <Zap className="h-4 w-4" data-id="element-89" />
          Ahorra US$3.60
        </div>

        <p className="text-[#5B7C5B] font-medium mb-6 md:mb-8 uppercase tracking-wide text-sm mt-6" data-id="element-90">
          Por tiempo limitado
        </p>

        <div className="mb-3 md:mb-4" data-id="element-91">
          <div className="flex items-center justify-center gap-3 mb-1" data-id="element-92">
            <span className="text-2xl md:text-3xl text-[#6B6560] line-through font-serif" data-id="element-93">
              US$9.99
            </span>
            <span className="inline-flex items-center gap-1 px-3 py-1 text-sm font-bold text-white bg-[#D4836B] rounded-full" data-id="element-94">
              <Tag className="h-3.5 w-3.5" data-id="element-95" />
              -36%
            </span>
          </div>
          <span className="text-5xl md:text-6xl font-serif font-bold text-[#2D2A26]" data-id="element-96">
            US$6.39
          </span>
          <p className="text-[#6B6560] mt-2" data-id="element-97">acceso inmediato a 4 PDFs</p>
        </div>

        <Button fullWidth className="mb-6 text-lg py-5" href="https://cuidarte360.com/cart/55936129859910:1" data-id="element-98">
          Comprar y descargar ahora
        </Button>

        <p className="text-sm text-[#6B6560]" data-id="element-99">
          Contenido educativo. Resultados varían según tolerancias y hábitos.
        </p>
      </div>
    </Section>;
}